import { createContext } from 'react';
import { defaultHomeProps } from './constants';
export const HomePropsContext = /*#__PURE__*/createContext(defaultHomeProps);